<!--  -->
<template>
  <div class="head">
    <div class="box">
      <span>中考招生报名系统(含中职）{{ year }}年度</span>
      <div>
        <span v-if="avtive != 1" class="shou left" @click="uppass()"
          >修改密码</span
        >
        <span class="shou" @click="shouye()">退出</span>
      </div>
    </div>
    <el-dialog
      title="温馨提示"
      :visible.sync="show"
      width="30%"
      :before-close="quexiao"
      center
    >
      <span>您确定退出系统吗？</span>
      <span slot="footer" class="dialog-footer">
        <div class="queding" @click="tiao()">确定</div>
      </span>
    </el-dialog>
    <el-dialog
      title="温馨提示"
      :visible.sync="show1"
      width="30%"
      :before-close="quexiao"
      center
    >
      <span>您确定要修改密码吗？修改密码后会退出系统重新登录</span>
      <span slot="footer" class="dialog-footer">
        <div class="queding" @click="tiao1()">确定</div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      avtive: "0", //0-显示修改密码 1-不显示修改密码
      show: false,
      show1: false,
      year: "",
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    "$store.state.niandu": {
      handler(newVal, oldVal) {
        console.log(newVal);
        this.year = newVal;
      },
      immediate: true,
      deep: true,
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    switch (window.location.hash) {
      case "#/czpassword":
        this.avtive = "1";
        break;
      default:
        this.avtive = "0";
    }
  },
  //方法集合
  methods: {
    //取消
    quexiao() {
      this.show = false;
      this.show1 = false;
    },
    //退出弹窗
    shouye() {
      this.show = true;
    },
    //修改密码弹窗
    uppass() {
      this.show1 = true;
    },
    //退出跳转
    tiao() {
      sessionStorage.removeItem("djdata");
      sessionStorage.removeItem("centerduty");
      this.$router.push({
        path: "/login",
      });
    },
    //修改密码跳转
    tiao1() {
      this.$router.push({
        path: "/czpassword",
      });
    },
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
/*@import url(); 引入公共css类*/
.head {
  width: 100%;
  height: 4rem;
  background-color: #2c9167;
  display: flex;
  justify-content: center;
  .box {
    width: 88%;
    color: #fff;
    font-size: 1.4rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
.shou {
  cursor: pointer;
}
.queding {
  width: 5rem;
  height: 2rem;
  background-color: #2c9167;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  cursor: pointer;
}
.left {
  margin-right: 1rem;
}
/deep/.el-dialog__header {
  background-color: #2c9167;
  padding: 0.8rem 0.8rem;
}
/deep/.el-dialog__title {
  line-height: 0.96rem;
  font-size: 0.8rem;
  color: #ffffff;
}
/deep/.el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}
/deep/.el-dialog__headerbtn {
  top: 1rem;
  right: 1rem;
  font-size: 0.88rem;
}
/deep/.el-dialog--center .el-dialog__body {
  text-align: center;
  padding: 2rem 1rem;
  font-size: 1rem;
}
/deep/.el-dialog--center .el-dialog__footer {
  text-align: center;
  display: flex;
  justify-content: center;
}
.dialog-footer {
  display: flex;
  align-items: center;
}
</style>
